import { Component, Inject, OnInit } from '@angular/core';
import { InputSelectSearchItem } from '@interfaces/input-select-search-item.interface';
import { TeamsService } from '@modules/teams/teams.service';
import { FormControl } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-select-teams-dialog',
  templateUrl: './select-teams-dialog.component.html',
  styleUrls: ['./select-teams-dialog.component.scss'],
})
export class SelectTeamsDialogComponent implements OnInit {
  public teamsSelect: InputSelectSearchItem[] = [];
  public teamControl = new FormControl();
  constructor(
    private teamService: TeamsService,
    private dialogRef: MatDialogRef<SelectTeamsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { filterTelephony?: boolean }
  ) {}

  public ngOnInit(): void {
    this.loadTeams();
  }

  public close() {
    this.dialogRef.close();
  }

  private async loadTeams() {
    let teams = await firstValueFrom(this.teamService.getTeamByUserId());

    if (this.data.filterTelephony) {
      teams = teams.filter((team) => team.modalityTelephony);
    }

    this.teamsSelect = teams.map((team) => {
      return {
        label: team.name,
        value: team as any,
      } as InputSelectSearchItem;
    });

    if (this.teamsSelect.length === 1) {
      this.teamControl.setValue(this.teamsSelect.shift()?.value);
      this.save();
    }
  }

  public save() {
    this.dialogRef.close(this.teamControl.value);
  }
}
